/** What `POST api/work-template/import-templates` answers (QA batch 16). */
export type TemplateImportResult = {
  templatesCreated?: number;
  subtasksCreated?: number;
  templateNames?: string[];
  skipped?: { line: number; templateName?: string | null; reason: string }[];
};

const plural = (count: number, word: string) =>
  `${count} ${word}${count === 1 ? "" : "s"}`;

/**
 * The toast after an import: how many templates/subtasks were added and which
 * rows were skipped (first 3 listed). Older servers answer without counts:
 * then the old "Template import successful".
 */
export const templateImportSummary = (
  result: unknown,
): { text: string; type: "success" | "warning" } => {
  const data = (result ?? {}) as TemplateImportResult;
  if (typeof data.templatesCreated !== "number") {
    return { text: "Template import successful", type: "success" };
  }
  const created = `Imported ${plural(
    data.templatesCreated,
    "template",
  )} with ${plural(data.subtasksCreated ?? 0, "subtask")}.`;
  const skipped = data.skipped ?? [];
  if (!skipped.length) return { text: created, type: "success" };
  const listed = skipped
    .slice(0, 3)
    .map((row) => `line ${row.line}: ${row.reason}`)
    .join(" ");
  const more = skipped.length > 3 ? ` …and ${skipped.length - 3} more.` : "";
  return {
    text: `${created} Skipped ${plural(
      skipped.length,
      "row",
    )} — ${listed}${more}`,
    type: "warning",
  };
};
